import React from 'react';
import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet';
import 'leaflet/dist/leaflet.css'; 

const Form = () => {
  const contactInfo = {
    title: 'Planifiez un appel avec moi pour voir si je peux vous aider',
    description: "Que vous souhaitiez démarrer un nouveau projet ou simplement discuter, n'hésitez pas à me contacter !",
    phone: '+33.6.61.12.30.92',
    email: 'olivier.codes@gmail.com',
    address: 'Strasbourg, France',
  };

  const illkirchCoordinates = { lat: 48.5474, lng: 7.7480 };

  return (
    <section className="contact-area primary-bg">
      <div className="container">
        <div className="row justify-content-between">
          {/* Informations de contact */}
          <div className="col-12 col-lg-4 order-last order-md-first">
            <div className="contact-info">
              <h3>{contactInfo.title}</h3>
              <p>{contactInfo.description}</p>

              <div className="content contact-form">
                <ul className="list-group list-group-flush">
                  <li className="list-group-item">
                    <i className="icon icon-phone"></i>
                    <a className="content" href={`tel:${contactInfo.phone}`}>{contactInfo.phone}</a>
                  </li>
                  <li className="list-group-item">
                    <i className="icon icon-envelope-open"></i>
                    <a className="content" href={`mailto:${contactInfo.email}`}>{contactInfo.email}</a>
                  </li>
                  <li className="list-group-item">
                    <i className="icon icon-location-pin"></i>
                    <a className="content" href="/#">{contactInfo.address}</a>
                  </li>
                </ul>
              </div>
            </div>
          </div>

          {/* Carte d'Illkirch */}
          <div className="col-12 col-lg-7 order-first order-md-last mt-sm-4 mt-lg-0">
            <div style={{ height: '400px', width: '100%' }}>
              <MapContainer center={illkirchCoordinates} zoom={13} scrollWheelZoom={false} style={{ height: '100%' }}>
                <TileLayer
                  url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                />
                <Marker position={illkirchCoordinates}>
                  <Popup>
                    Illkirch, France
                  </Popup>
                </Marker>
              </MapContainer>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Form;
